import { useEffect, useState } from 'react';
import { Source, Layer, Popup, useMap } from 'react-map-gl/mapbox';

const RuralRoadsLayer = ({ geojson, visibleIds }) => {
  const [popupInfo, setPopupInfo] = useState(null);
  const { current: map } = useMap();

  const visibleFeatures = geojson?.features?.filter(f => visibleIds.has(f.properties.id)) ?? [];
  const allLayerIds = geojson?.features?.map(f => `rural-road-${f.properties.id}`) ?? [];

  useEffect(() => {
    if (!map || !geojson) return;

    const handleClick = e => {
      const features = map.queryRenderedFeatures(e.point, { layers: allLayerIds });
      if (features.length > 0) {
        setPopupInfo(null);
        setTimeout(() => {
          setPopupInfo({
            longitude: e.lngLat.lng,
            latitude: e.lngLat.lat,
            name: features[0].properties.name
          });
        }, 0);
      } else {
        setPopupInfo(null);
      }
    };

    map.on('click', handleClick);
    return () => map.off('click', handleClick);
  }, [map, geojson]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!map || !geojson) return;

    allLayerIds.forEach(id => {
      map.on('mouseenter', id, () => { map.getCanvas().style.cursor = 'pointer'; });
      map.on('mouseleave', id, () => { map.getCanvas().style.cursor = ''; });
    });

    return () => {
      allLayerIds.forEach(id => {
        map.off('mouseenter', id);
        map.off('mouseleave', id);
      });
    };
  }, [map, geojson]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!geojson) return null;

  return (
    <>
      {visibleFeatures.map(feature => (
        <Source
          key={feature.properties.id}
          id={`rural-road-${feature.properties.id}`}
          type="geojson"
          data={{ type: 'FeatureCollection', features: [feature] }}
        >
          <Layer
            id={`rural-road-${feature.properties.id}`}
            type="line"
            paint={{
              'line-color': feature.properties.color || '#ff0000',
              'line-width': 3
            }}
          />
        </Source>
      ))}

      {popupInfo && (
        <Popup
          longitude={popupInfo.longitude}
          latitude={popupInfo.latitude}
          anchor="bottom"
          onClose={() => setPopupInfo(null)}
        >
          <div style={{ lineHeight: '1.4em' }}>
            <div>{popupInfo.name}</div>
          </div>
        </Popup>
      )}
    </>
  );
};

export default RuralRoadsLayer;
